import React from 'react';

import { connect } from 'react-redux';

import config from '../../../config.json';
import langStrings from '../../../lang/languageStrings.json';
import styles from './Footer.module.css';

const footer = props => {
  return (
    <div className={styles.Footer}>
      <p><a href={config.homepage}>{config.institution_name}</a></p>
      <p><a href={config.imprint}>{langStrings[props.language].imprint}</a></p>
      <p><a href={config.privacy_terms}>{langStrings[props.language].privacy_terms}</a></p>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    language: state.rs.language
  };
};

export default connect(mapStateToProps)(footer);
